import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=b5545a74&scoped=true&"
import script from "@/scripts/Password/Success/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Password/Success/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5545a74",
  null
  
)

export default component.exports